import { Button, Paper, Typography, useTheme } from '@material-ui/core';
import React from 'react';
import { useDialog } from '../Common/DialogContext';

export const TokenDialogTitle = () => {

  return (
    <Typography variant="h5" component="span" color="secondary">
        TOKEN ANDA
    </Typography>
  );
};
export const TokenDialogContent = (props) => {
  const { token } = props;
  const theme = useTheme();
  return (
    <div>
      <Paper
        style={{
          backgroundColor:
                        theme.palette.type === 'dark' ? '#212121' : '#dadada',
        }}
      >
        <Typography
          variant="h5"
          align="center"
          style={{
            color: theme.palette.type === 'dark' ? '#e0e0e0' : '#0e0e0e',
          }}
        >
          {token}
        </Typography>
      </Paper>
      <Typography>
        Harap simpan token tersebut untuk melihat status tiket pelayanan Anda.
        Sebuah email seharusnya telah dikirimkan ke email Anda dan berisi
        token yang sama.
      </Typography>
    </div>
  );
};

export const TokenDialogActions = () => {
  const dialogHelper = useDialog();
  return (
    <Button onClick={dialogHelper.closeDialog} color="primary" autoFocus>
        OK
    </Button>);
};